const MAIN_TOKEN_KEY = "token";
const MICRO_TOKEN_KEY = "jyx_token";
const USER_DISPLAY_NAME_KEY = "user_display_name";
const IP_USER_KEY = "ip_user";
let authSessionVersion = 0;

export function getAuthSessionVersion() {
  return authSessionVersion;
}

function stripBearerPrefix(token) {
  if (typeof token !== "string") {
    return "";
  }
  return token.replace(/^Bearer\s+/i, "").trim();
}

function getStorageToken(key) {
  const token = localStorage.getItem(key);
  return token ? token.trim() : "";
}

function setStorageToken(key, token) {
  if (token) {
    localStorage.setItem(key, token);
  } else {
    localStorage.removeItem(key);
  }
}

function getRequestAuthToken(config) {
  if (!config || !config.headers) {
    return "";
  }
  return stripBearerPrefix(config.headers.Authorization || config.headers.authorization || "");
}

export function getMainToken() {
  return getStorageToken(MAIN_TOKEN_KEY);
}

export function setMainToken(token) {
  authSessionVersion += 1;
  setStorageToken(MAIN_TOKEN_KEY, token);
}

export function clearMainToken() {
  authSessionVersion += 1;
  localStorage.removeItem(MAIN_TOKEN_KEY);
}

export function getMicroToken() {
  return getStorageToken(MICRO_TOKEN_KEY);
}

export function setMicroToken(token) {
  setStorageToken(MICRO_TOKEN_KEY, token);
}

export function clearMicroToken() {
  localStorage.removeItem(MICRO_TOKEN_KEY);
}

export function clearAllAuthTokens() {
  clearMainToken();
  clearMicroToken();
}

export function getUserDisplayName() {
  return localStorage.getItem(USER_DISPLAY_NAME_KEY) || "";
}

export function setUserDisplayName(displayName) {
  if (displayName) {
    localStorage.setItem(USER_DISPLAY_NAME_KEY, displayName);
  } else {
    localStorage.removeItem(USER_DISPLAY_NAME_KEY);
  }
}

export function getIpUserFlag() {
  return localStorage.getItem(IP_USER_KEY);
}

export function setIpUserFlag(flag) {
  if (flag === null || flag === undefined || flag === "") {
    localStorage.removeItem(IP_USER_KEY);
    return;
  }
  localStorage.setItem(IP_USER_KEY, String(flag));
}

export function isMicroTokenRequest(config) {
  const requestToken = getRequestAuthToken(config);
  const microToken = getMicroToken();
  if (!requestToken || !microToken) {
    return false;
  }
  return requestToken === stripBearerPrefix(microToken);
}

export function syncMainTokenFromResponse(response) {
  const nextToken = response && response.headers ? response.headers.authorization : "";
  const requestToken = getRequestAuthToken(response && response.config);
  // 只允许当前主会话续期；子 token 或旧会话响应不得改写主身份。
  if (nextToken && requestToken && requestToken === stripBearerPrefix(getMainToken())) {
    setStorageToken(MAIN_TOKEN_KEY, nextToken);
  }
}

export function buildOauthRedirectUrl(payload = {}) {
  const currentHost = window.location.hostname;
  const oauthServer =
    currentHost === "192.168.0.39" || currentHost === "192.168.0.146" || currentHost === "localhost" || currentHost === "127.0.0.1"
      ? `http://${currentHost === "127.0.0.1" ? "127.0.0.1" : currentHost}:8082`
      : "https://sso.cxstar.cn";

  const clientId = payload.client_id || "";
  const state = payload.state || "";
  const redirectUrl = payload.redirect_url || payload.redirect_uri || window.location.href;

  return `${oauthServer}/oauth/authorize?client_id=${clientId}&redirect_uri=${encodeURIComponent(redirectUrl)}&state=${state}&response_type=code`;
}

export function replaceRequestAuthToken(config, token) {
  if (!config.headers) {
    config.headers = {};
  }
  config.headers.Authorization = token;
  config.headers.token = token;
  return config;
}
